import { hasPermission, fetchAllPermissions } from "@/composables/usePermissions.js"
import { user } from "@/composables/useAccount.js"

const nonPartnerGuard = (to, from, next) => {
  const partnerRoles = user().roles?.filter(role =>
    ["partner", "direct_reseller", "distributor", "involved_reseller"].includes(role),
  ) || []
  if (partnerRoles.length === 0) {
    return next("/no-partner")
  }
  next()
}

const permissionGuard = permission => async (to, _, next) => {
  const permissions = await fetchAllPermissions()
  if (!hasPermission(permissions, permission, to.params.id)) {
    return next("/no-permission")
  }
  next()
}

const roleGuard = (roles, path) => (_, __, next) => {
  if (roles.some(role => user().roles.includes(role))) {
    next()
  }
  else if (path) {
    next(path)
  }
  else {
    next("/no-permission")
  }
}

export {
  nonPartnerGuard,
  permissionGuard,
  roleGuard,
}
